import React from "react";
import PropTypes from "prop-types";
import axios from "axios";

import Modal from "../../Modal";
import FormTemplate from "./Form";

class NewTemplate extends React.Component {
  state = {
    loading: false,
    messageType: "E-Mail",
    name: "",
    message: ""
  };

  render() {
    const { show, onClose } = this.props;
    const { messageType, name, message, loading } = this.state;

    return (
      <Modal title="New Template" visible={show} onClose={onClose}>
        <FormTemplate
          messageType={messageType}
          name={name}
          message={message}
          onChangeType={this.handlerChangeType}
          onChangeName={this.handlerChangeName}
          onChangeMessage={this.handlerChangeMessage}
        />

        <button
          type="button"
          className="btn btn-pink btn-block btn-raised"
          disabled={loading}
          onClick={this.handlerCreate}
        >
          SAV{loading ? "ING..." : "E"}
        </button>
      </Modal>
    );
  }

  resetState = () =>
    this.setState({
      loading: false,
      messageType: "E-Mail",
      name: "",
      message: ""
    });

  handlerChangeType = messageType =>
    this.setState({ messageType: messageType });
  handlerChangeName = e => this.setState({ name: e.target.value });
  handlerChangeMessage = e => this.setState({ message: e.target.value });

  handlerCreate = () => {
    this.setState({ loading: true });

    const { messageType, name, message } = this.state;

    axios
      .post("/message_templates", {
        message_type: messageType,
        name: name,
        message: message
      })
      .then(({ data }) => {
        toastr.success("Created");
        this.resetState();
        this.props.onAdded(data);
      })
      .catch(({ response }) => {
        if (response && response.data && response.data.message) {
          toastr.error(response.data.message.join("</br>"));
        }

        this.setState({ loading: false });
      });
  };
}

NewTemplate.propTypes = {
  show: PropTypes.bool,
  onClose: PropTypes.func,
  onAdded: PropTypes.func
};

NewTemplate.defaultProps = {
  show: false
};

export default NewTemplate;
